import React from 'react';

import styles from '../../../PerformancePortalLanding.module.css';

interface CustomLegendIconProps {
  fill: string;
  color: string;
  value: string;
}

const CustomLegendIcon: React.FC<CustomLegendIconProps> = ({
  fill,
  color,
  value,
}: CustomLegendIconProps): React.ReactElement => {
  return (
    <span className={styles.legendItem}>
      <svg
        className={styles.rechartsSurface}
        width='30'
        height='40'
        viewBox='0 0 32 32'
        style={{ verticalAlign: 'middle', padding: '0 10px' }}
      >
        {/* d is the Path, comes from the line chart generated by Recharts */}
        <path
          strokeWidth='4'
          fill={fill}
          stroke={color}
          d='M0,16h10.66 A5.33,5.33,0,1,1,21.33,16 H32M21.33,16 A5.33,5.33,0,1,1,10.66,16'
          className='recharts-legend-icon'
        />
      </svg>
      <span style={{ display: 'inline-block' }}>{value}</span>
    </span>
  );
};

export default CustomLegendIcon;
